import React, { useMemo, useState } from "react";
import {deliveryInitation} from "../../../../../../reduxLib/deliveryLib";
import {useDispatch} from "react-redux";

function DeliveryInitiateModal({
                                   isOpen,
                                   onClose,
                                   delivery,
                                   invoiceId,
                               })
{
    const dispatch = useDispatch();
const [trackingNumber, setTrackingNumber] = useState("");
const [deliveryEstimationDays, setDeliveryEstimationDays] = useState("");

const estimatedArrivalDate = useMemo(() => {
    if (!deliveryEstimationDays) return "";

    const days = Number(deliveryEstimationDays);

    if (Number.isNaN(days) || days < 0) return "";

    const date = new Date();
    date.setDate(date.getDate() + days);

    return date.toLocaleDateString("el-GR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
}, [deliveryEstimationDays]);

if (!isOpen || !delivery) return null;



    const handleInitiateDelivery = async () => {

        const toLocalDatePayload = (dateString) => {
            if (!dateString) return null;

            const [day, month, year] = dateString.split("/");

            return `${year}-${month}-${day}`;
        };

        //console.log(delivery);
        const payload = {
            //...delivery,
            deliveryID: delivery.deliveryID,
            tracking_Number: trackingNumber,
            invoiceId: invoiceId,
            deliveryEstimationDays: Number(deliveryEstimationDays),
            deliveryEstimationArival: toLocalDatePayload(estimatedArrivalDate),
            recipientEmail: delivery.orderOwnerEmail,
        };
        console.log(payload);

       await dispatch(deliveryInitation(payload));
    };

return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl relative">

            <div className="border-b px-6 py-4 flex justify-between items-center">
                <h2 className="text-xl font-bold text-custom-green">
                    Delivery Initiation
                </h2>

                <button
                    onClick={onClose}
                    className="text-gray-500 hover:text-black"
                >
                    <i className="fa-solid fa-xmark text-xl"></i>
                </button>
            </div>

            <div className="p-6 space-y-4">
                <div>
                    <label className="text-sm font-medium">
                        Recipient
                    </label>

                    <input
                        type="text"
                        value={delivery.orderOwnerEmail || ""}
                        disabled
                        className="w-full border rounded-lg p-2 mt-1 bg-gray-100"
                    />
                </div>

                <div>
                    <label className="text-sm font-medium">
                        Tracking Number
                    </label>

                    <input
                        type="text"
                        value={trackingNumber}
                        onChange={(e) => setTrackingNumber(e.target.value)}
                        className="w-full border rounded-lg p-2 mt-1"
                        placeholder="Enter tracking number"
                    />
                </div>

                <div>
                    <label className="text-sm font-medium">
                        Delivery Estimation Arrival
                    </label>

                    <input
                        type="number"
                        min="0"
                        value={deliveryEstimationDays}
                        onChange={(e) =>
                            setDeliveryEstimationDays(e.target.value)
                        }
                        className="w-full border rounded-lg p-2 mt-1"
                        placeholder="Estimated days until arrival"
                    />
                </div>

                <div>
                    <label className="text-sm font-medium">
                        Estimated Arrival Date
                    </label>

                    <input
                        type="text"
                        value={estimatedArrivalDate}
                        disabled
                        className="w-full border rounded-lg p-2 mt-1 bg-gray-100"
                        placeholder="Calculated automatically"
                    />
                </div>

            </div>

            <div className="border-t px-6 py-4">
                <button
                    onClick={handleInitiateDelivery}
                    className="w-full bg-custom-green text-white px-4 py-3 rounded-lg font-semibold hover:opacity-90"
                >
                    Delivery Initiation
                </button>
            </div>
        </div>
    </div>
);
}

export default DeliveryInitiateModal;